import { render, staticRenderFns } from "./IconNext.vue?vue&type=template&id=5f1c9e8d"
import script from "./IconNext.vue?vue&type=script&lang=js"
export * from "./IconNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports